import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  Select,
  LoadingOverlay,
  PasswordInput,
  MultiSelect,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { ASSIGN_WAREHOUSE, CREATE_PRODUCT_CATEGORIES } from "apollo/mutuations";
import {
  GET_REGIONS,
  GET_SALESES_WAREHOUSE,
  GET_UNASSIGNED_WAREHOUSES,
  GET_WARE_HOUSES,
} from "apollo/queries";
import { customLoader } from "components/utilities/loader";

const AssginWarehouseModal = ({ id, setOpened, size, activePage }) => {
  const form = useForm({
    initialValues: {
      warehouse_ids: [],
      region: "",
    },
    validate: {
      warehouse_ids: (value) =>
        value.length > 0 ? null : "At least one warehouse must be selected",
    },
  });
  const [dropDownData, setDropDownData] = useState([]);
  const [regionDropDownData, setRegionDropDownData] = useState([]);
  const [unassignedWarehouses, setUnassignedWarehouses] = useState([]);

  const { loading: region_loading, refetch } = useQuery(GET_REGIONS, {
    variables: { first: 100, page: 1 },
    onCompleted(data) {
      const newArr = data.regions.data.map((element) => ({
        label: element.name,
        value: element.id,
      }));
      setRegionDropDownData(newArr);
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get region",
      });
    },
  });

  const { loading: warehouse_loading, refetch: warehouseFetch } = useQuery(
    GET_UNASSIGNED_WAREHOUSES,
    {
      variables: {
        ordered_by: [
          {
            column: "CREATED_AT",
            order: "DESC",
          },
        ],
      },
      onCompleted(data) {
        const warehouses = data.unassignedWarehouses
          .filter((warehouse) => warehouse.status === "ACTIVE")
          .map((warehouse) => ({
            label: `${warehouse.name} - ${warehouse.region.name}`,
            value: warehouse.id,
          }));
        setUnassignedWarehouses(data.unassignedWarehouses);
        setDropDownData(warehouses);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to get warehouses",
        });
      },
    }
  );

  useEffect(() => {
    refetch();
    warehouseFetch();
  }, []);

  // Mutation
  const [addProductCategory, { loading: commissionLoading }] = useMutation(
    ASSIGN_WAREHOUSE,
    {
      update(cache, { data: { assignWarehouses } }) {
        cache.updateQuery(
          {
            query: GET_SALESES_WAREHOUSE,
            variables: {
              id: id,
            },
          },
          (data) => {
            return {
              getAssignedWarehouses: {
                ...data.getAssignedWarehouses,
                data: [assignWarehouses, ...data.getAssignedWarehouses],
              },
            };
          }
        );
      },
    }
  );

  const { height } = useViewportSize();

  const submit = () => {
    if (form.values.warehouse_ids.length === 0) {
      showNotification({
        color: "red",
        title: "Error",
        message: "At least one warehouse must be selected",
      });
      return;
    }
    addProductCategory({
      variables: {
        id: String(id),
        warehouse_ids:
          form.values.warehouse_ids.length > 0 ? form.values.warehouse_ids : [],
      },
      onCompleted() {
        showNotification({
          color: "green",
          title: "Success",
          message: "Warehouses assigned successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to assign warehouses",
        });
      },
    });
  };

  const handleCategoryChange = (val) => {
    form.setFieldValue("warehouse_ids", val || []);
  };

  const setRegionDropDownValue = (val) => {
    form.setFieldValue("region", val);
    if (val) {
      const warehouses = unassignedWarehouses
        ?.filter(
          (warehouse) =>
            warehouse.region.id === val && warehouse.status === "ACTIVE"
        )
        .map((warehouse) => ({
          label: `${warehouse.name} - ${warehouse.region.name}`,
          value: warehouse.id,
        }));
      setDropDownData(warehouses);
      form.setFieldValue("warehouse_ids", []);
    } else {
      const warehouses = unassignedWarehouses
        .filter((warehouse) => warehouse.status === "ACTIVE")
        .map((warehouse) => ({
          label: `${warehouse.name} - ${warehouse.region.name}`,
          value: warehouse.id,
        }));
      setDropDownData(warehouses);
      form.setFieldValue("warehouse_ids", []);
    }
  };

  return (
    <>
      <LoadingOverlay
        visible={region_loading || warehouse_loading || commissionLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <Select
                  searchable
                  clearable
                  data={regionDropDownData}
                  value={form.values.region}
                  onChange={setRegionDropDownValue}
                  label="Region"
                />
              </Grid.Col>
              {dropDownData.length > 0 && (
                <Grid.Col span={4}>
                  <MultiSelect
                    searchable
                    clearable
                    data={dropDownData}
                    value={form.values.warehouse_ids}
                    onChange={handleCategoryChange}
                    label="Warehouses"
                    error={form.errors.warehouse_ids}
                  />
                </Grid.Col>
              )}
            </Grid>

            <Grid>
              <Grid.Col span={6}>
                <Button
                  style={{
                    width: "30%",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  color="blue"
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default AssginWarehouseModal;
